import { component } from 'picoapp'
import Drawer from '../lib/drawer'

export default component((node, ctx) => {
    const drawer = Drawer(node, node.parentNode)
    const { product } = JSON.parse(document.querySelector('.js-data').innerHTML)
    const variantsButtonText = document.querySelector('.js-variants-button')
    const hasSelectedVariant = document.querySelector('[data-selectedvariant]')

    const closeDrawerBtn = node.querySelector('[data-close-variant-drawer]')
    const openDrawerBtn = document.querySelector('[data-open-variant-drawer]')

    closeDrawerBtn?.addEventListener('click', () => {
        drawer.close()
    })

    openDrawerBtn?.addEventListener('click', () => {
        drawer.open()
    })

    ctx.on('variant:openDrawer', () => {
        drawer.open()
    })

    const swatches = node.querySelectorAll('.product__variants--swatch input')
    swatches.forEach((ele, i) => {
        ele.addEventListener('change', () => {
            ele.checked = false
            const { index } = ele.dataset
            const select = document.querySelector(`#product-${product.id}-option-${index}`)
            select.selectedIndex = i
            select.dispatchEvent(new Event('change'))
            variantsButtonText.innerHTML = ele.getAttribute('data-display-text')
            drawer.close()
            hasSelectedVariant.setAttribute('data-selectedvariant', ele.getAttribute('id'))            
        })
    })
})
